/**
 * Truncates a full Google Maps address string to "City, State" only.
 *
 * Handles two common formats returned by Google Places:
 *   With street:    "241 Front St, Key West, FL 33040, USA"  → "Key West, FL"
 *   Without street: "Incline Village, NV 89451, USA"         → "Incline Village, NV"
 *                   "Incline Village, Nevada, USA"            → "Incline Village, Nevada"
 *
 * Street presence is detected by checking whether the first
 * comma-separated segment starts with a digit.
 *
 * @param {string} address - Full address string from publicData.location.address
 * @returns {string} "City, State" or the original string if it cannot be parsed
 */
export const truncateAddressToCity = address => {
  if (!address) return '';
  const parts = address.split(',').map(p => p.trim()).filter(Boolean);
  if (parts.length < 2) return address;
  const hasStreet = /^\d/.test(parts[0]);
  if (hasStreet && parts.length >= 3) {
    const city = parts[1];
    const state = parts[2].replace(/\s+\d{5}(-\d{4})?$/, '').trim();
    return `${city}, ${state}`;
  }
  // No street prefix — parts[0] is the city, parts[1] is the state/region.
  const city = parts[0];
  const state = parts[1].replace(/\s+\d{5}(-\d{4})?$/, '').trim();
  return `${city}, ${state}`;
};
